(ns storrito.instagram.story.editor.emojis)

(def weather
  [{:name 'Storrito_smiley'
    :short_names ["storrito_rainbow"]
    :keywords ["rainbow"]
    :imageUrl "/emojicons/custom/emoji_rainbow.png"}

   {:name 'Storrito_smiley'
    :short_names ["storrito_sunny"]
    :keywords ["sun" "sunny"]
    :imageUrl "/emojicons/custom/emoji_sunny.png"}

   {:name 'Storrito_smiley'
    :short_names ["rainy"]
    :keywords ["rain"]
    :imageUrl "/emojicons/custom/emoji_rainy.png"}

   {:name 'Storrito_smiley'
    :short_names ["snow"]
    :keywords ["winter" "snow"]
    :imageUrl "/emojicons/custom/emoji_snow.png"}

   {:name 'Storrito_smiley'
    :short_names ["leaf"]
    :keywords ["autumn" "leaf"]
    :imageUrl "/emojicons/custom/emoji_leaf.png"}

   {:name 'Storrito_smiley'
    :short_names ["storrito_new_moon"]
    :keywords ["night" "moon"]
    :imageUrl "/emojicons/custom/emoji_new_moon.png"}

   {:name 'Storrito_smiley'
    :short_names ["storrito_moon"]
    :keywords ["weather" "moon"]
    :imageUrl "/emojicons/custom/emoji_crescent_moon.png"}

   {:name 'Storrito_smiley'
    :short_names ["cloudy"]
    :keywords ["weather" "cloudy"]
    :imageUrl "/emojicons/custom/emoji_cloudy.png"}

   {:name 'Storrito_smiley'
    :short_names ["cloudy_1"]
    :keywords ["weather" "cloudy"]
    :imageUrl "/emojicons/custom/emoji_cloudy_1.png"}])

(def christmas-emojis
  [{:name "Storrito_smiley"
    :short_names ["xmas_milk"]
    :keywords ["milk" "cookies" "christmas"]
    :imageUrl "/emojicons/custom/christmas/emoji_milk.png"}
   {:name "Storrito_smiley"
    :short_names ["xmas_deer"]
    :keywords ["deer" "christmas"]
    :imageUrl "/emojicons/custom/christmas/emoji_deer.png"}
   {:name "Storrito_smiley"
    :short_names ["xmas_mug"]
    :keywords ["mug" "christmas"]
    :imageUrl "/emojicons/custom/christmas/emoji_mug.png"}
   {:name "Storrito_smiley"
    :short_names ["xmas_pullover_1"]
    :keywords ["pullover" "christmas"]
    :imageUrl "/emojicons/custom/christmas/emoji_pullover_1.png"}
   {:name "Storrito_smiley"
    :short_names ["xmas_pullover_2"]
    :keywords ["pullover" "christmas"]
    :imageUrl "/emojicons/custom/christmas/emoji_pullover_2.png"}
   {:name "Storrito_smiley"
    :short_names ["xmas_sack"]
    :keywords ["sack" "christmas" "present"]
    :imageUrl "/emojicons/custom/christmas/emoji_sack.png"}
   {:name "Storrito_smiley"
    :short_names ["xmas_santa_hat"]
    :keywords ["santa" "hat" "christmas"]
    :imageUrl "/emojicons/custom/christmas/emoji_santa_hat.png"}
   {:name "Storrito_smiley"
    :short_names ["xmas_snowman"]
    :keywords ["snowman" "christmas"]
    :imageUrl "/emojicons/custom/christmas/emoji_xmas_snowman.png"}
   {:name "Storrito_smiley"
    :short_names ["xmas_sweet"]
    :keywords ["sweet" "sugar" "christmas"]
    :imageUrl "/emojicons/custom/christmas/emoji_xmas_sweet.png"}
   {:name "Storrito_smiley"
    :short_names ["xmas_wreath"]
    :keywords ["wreath" "christmas"]
    :imageUrl "/emojicons/custom/christmas/emoji_wreath.png"}])

(def black-friday-emojis
  [{:name "Storrito_smiley"
    :short_names ["black_friday_badge"]
    :keywords ["black friday" "badge" "price"]
    :imageUrl "/emojicons/custom/black-friday/emoji_black_friday_badge.png"}

   {:name "Storrito_smiley"
    :short_names ["black_friday_ball"]
    :keywords ["black friday" "tag" "price"]
    :imageUrl "/emojicons/custom/black-friday/emoji_black_friday_ball.png"}

   {:name "Storrito_smiley"
    :short_names ["black_friday_tag_1"]
    :keywords ["black friday" "tag" "price"]
    :imageUrl "/emojicons/custom/black-friday/emoji_black_friday_tag_1.png"}

   {:name "Storrito_smiley"
    :short_names ["black_friday_tag_2"]
    :keywords ["black friday" "tag" "price"]
    :imageUrl "/emojicons/custom/black-friday/emoji_black_friday_tag_2.png"}])

(def party-emojis
  [{:name "Storrito_smiley"
    :short_names ["party_confetti"]
    :keywords ["party" "confetti"]
    :imageUrl "/emojicons/custom/party/emoji_party_confetti.png"}
   {:name "Storrito_smiley"
    :short_names ["party_confetti_2"]
    :keywords ["party" "confetti"]
    :imageUrl "/emojicons/custom/party/emoji_party_confetti_2.png"}])

(def storrito-emojis
  [{:name '"Storrito_smiley"
    :short_names ["storrito_emoji_1"]
    :keywords ["storrito"]
    :imageUrl "/emojicons/custom/standard/emoji_storrito_1.png"}

   {:name '"Storrito_smiley"
    :short_names ["storrito_swipe_up"]
    :keywords ["storrito" "swipe"]
    :imageUrl "/emojicons/custom/standard/emoji_swipe_up.png"}

   {:name '"Storrito_smiley"
    :short_names ["instagram_glasses"]
    :keywords ["love" "instagram"]
    :imageUrl "/emojicons/custom/standard/emoji_instagram_glasses.png"}

   {:name '"Storrito_smiley"
    :short_names ["instagram_love"]
    :keywords ["love" "instagram"]
    :imageUrl "/emojicons/custom/standard/emoji_instagram_love.png"}

   {:name '"Storrito_smiley"
    :short_names ["instagram_coffee"]
    :keywords ["storrito" "gingerbread"]
    :imageUrl "/emojicons/custom/standard/emoji_instagram_coffee.png"}

   {:name '"Storrito_smiley"
    :short_names ["storrito_wine"]
    :keywords ["wine"]
    :imageUrl "/emojicons/custom/standard/emoji_wine.png"}

   {:name '"Storrito_smiley"
    :short_names ["storrito_cocktail"]
    :keywords ["holiday" "cocktail"]
    :imageUrl "/emojicons/custom/standard/emoji_cocktail.png"}

   {:name '"Storrito_smiley"
    :short_names ["storrito_donut"]
    :keywords ["sweet" "donut"]
    :imageUrl "/emojicons/custom/standard/emoji_donut.png"}

   {:name '"Storrito_smiley"
    :short_names ["storrito_cupcake"]
    :keywords ["storrito" "cupcake"]
    :imageUrl "/emojicons/custom/standard/emoji_cupcake.png"}

   {:name '"Storrito_smiley"
    :short_names ["storrito_apple"]
    :keywords ["storrito" "apple"]
    :imageUrl "/emojicons/custom/standard/emoji_apple.png"}

   {:name '"Storrito_smiley"
    :short_names ["storrito_medal"]
    :keywords ["storrito" "medal"]
    :imageUrl "/emojicons/custom/standard/emoji_medal.png"}

   {:name '"Storrito_smiley"
    :short_names ["giftbox"]
    :keywords ["storrito" "swipe"]
    :imageUrl "/emojicons/custom/standard/emoji_giftbox.png"}])

(def custom-emoji-groups
  "The custom emojis as `[label emojis]` in the order of the editor2
   Emoji sidebar, the seasonal ones last."
  [["Everyday" storrito-emojis]
   ["Party" party-emojis]
   ["Christmas" christmas-emojis]
   ["Black Friday" black-friday-emojis]])